module.exports = __webpack_public_path__ + "img/antes_despues_207.9e6adb6f.png";